import React, { ReactElement, useEffect, useState } from 'react';
import className from 'classnames/bind';
import { connect } from 'react-redux';
import RateInfoDropdown from '../../molecules/RateInfoDropdown';
import Constants from './Constants';
import styles from './index.pcss';
import { showModal } from '../../../actions/shared/modal';
import { getProductItemPDP, gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import {
  getShowPDPRateSection,
  getEnableRating,
  getShowReviewProdBtn,
  getShowRateProdBtn,
  getEnableReviewFlag
} from '../../selectors/featureFlagsSelector';
import UnrateItems from '../../atoms/UnrateItems';

const cx = className.bind(styles);

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => dispatch(showModal(name, config))
  };
};
const mapStateToProps = state => ({
  enableRating: getEnableRating(state?.flags, state),
  enableReview: getEnableReviewFlag(state) === 'ON',
  showPDPRateSection: getShowPDPRateSection(state?.flags),
  showReviewProdBtn: getShowReviewProdBtn(state?.flags),
  showRateProdBtn: getShowRateProdBtn(state?.flags),
});
const connector = connect(mapStateToProps, mapDispatchToProps);
const ProductRatingsCard = ({
  luxe,
  isFleek,
  getAggregateRating,
  getSubRatings,
  productCode,
  productName,
  productBrand,
  imageUrl,
  customerWords,
  showModal,
  isSignedIn,
  product_id,
  product_brick,
  enableRating,
  enableReview,
  showPDPRateSection,
  showReviewProdBtn,
  showRateProdBtn,
  productData
}: {
  luxe: boolean;
  isFleek: boolean;
  getAggregateRating: any;
  getSubRatings: any;
  productCode: any;
  productName: string;
  productBrand: string;
  imageUrl: string;
  customerWords: any;
}): ReactElement => {
  const openCtaLabel = Constants.ctaOpenLabel;
  const closeCtaLabel = Constants.ctaCloseLabel;
  const [toggleOn, setToggleOn] = useState(false);
  useEffect(() => {
    getAggregateRating &&
      gtmEventPush({
        event: 'pdp_ratings_available',
        event_category: 'reviews & ratings interactions',
        event_action: 'pdp ratings available',
        event_label: 'activation event',
        page_type: 'product page'
      });
  }, []);
  const rateProductModal = isWriteAReview => {
    showModal('rating-halfcard', {
      state: {
        deviceType: 'mobile',
        rating: '0',
        pageToDisplay: 'ratingHalfCard',
        displayFeedBackPage: true,
        isfromWriteFeedBack: true,
        isFeedBackSubmitted: true,
        isFromPDP: true,
        sourcePage: 'PDP',
        pageName: 'pdp screen',
        pageType: 'product page',
        productDetails: {
          brandName: productBrand,
          description: productName,
          imageUrl,
          skuId: productCode,
          productCode,
          optionCode: productCode,
          brickCode: product_brick
        }
      }
    });
    if (isWriteAReview) {
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews_rating_interactions',
        event_action: 'Write overall review',
        product_id: productCode,
        ...(product_brick.length > 0 && { product_brick }),
        product_name: productName,
        pageName: 'pdp screen',
        pageType: 'product page',
        store_type: 'ajio'
      });
      // segment Push event
      segmentEventPush({
        event: 'Review Widget Interaction',
        event_category: 'reviews_rating_interactions',
        event_action: 'Write overall review',
        component_name:'Product Rating',
        products:[{ ...getProductItemPDP(productData)}],
        screenName: 'pdp screen',
        // pageType: 'product page',
        store_type: 'ajio'
      });
    }
  };
  console.log('PRODUCT RATING');
  return (
    <>
      {getAggregateRating?.averageRating && (
        <RateInfoDropdown
          title={!luxe ? 'Ratings' : ''}
          ctaOpenLabel={openCtaLabel}
          ctaCloseLabel={closeCtaLabel}
          isUnderLineText={!!luxe}
          luxe={luxe}
          isFleek={isFleek}
          isPdpMoreInfo={true}
          aggregateRating={getAggregateRating}
          subRatings={getSubRatings}
          productCode={productCode}
          productName={productName}
          productBrand={productBrand}
          imageUrl={imageUrl}
          customerWords={customerWords}
          product_id={productCode}
          product_brick={product_brick}
          productData={productData}
          toggleOn={() => {
          sessionStorage.setItem('exitIntent', 'true'); 
          setToggleOn(!toggleOn)}
          
         }
        />
      )}

      { enableRating && showPDPRateSection && (
        <UnrateItems
          enableReview={enableReview}
          enableRating={enableRating}
          showRateProdBtn={showRateProdBtn}
          showReviewProdBtn={showReviewProdBtn}
          isDesktop={false}
          rateProductModal={rateProductModal}
          isRating={getAggregateRating?.averageRating ? true : false}
          toggleOn={toggleOn}
          isFleek={isFleek}
        />
      )}
    </>
  );
};

export default connector(ProductRatingsCard);
